<template>
    <Layout>
        <div class="sticky-header">
            <div class="row">
                <div class="col-lg-12 col-sm-12">
                    <h4 class="header-title pb-3">
                        <a @click="$router.push('/')" class="ml-2 cursor-pointer">
                            <i class="fa fa-arrow-left"></i></a>
                        <span class="ml-3">Recobros</span>
                    </h4>
                    <div class="bg-light p-3 reporte-btns-container">
                        <div class=" p-1 btn__reporte">
                            <div @click="$router.push('/recobro/default/0')" class="item-menu item-reporte">
                                Búsqueda de recobros
                            </div>
                        </div>
                        <div class="p-1 btn__reporte">
                            <div @click="$router.push('/recobro-crear?nt=0')" class="item-menu item-reporte">
                                Creación de recobro
                            </div>
                        </div>
<!--                            <div class="col-6 p-1">
                                <div class="item-menu">
                                    Pago de <br/> Siniestros
                                </div>
                            </div>
                            <div class="col-6 p-1">
                                <div class="item-menu">
                                    Pago de <br/> recobro
                                </div>
                            </div>
                            <div class="col-6 p-1">
                                <div class="item-menu">
                                    Pago de <br/> Salvamentos
                                </div>
                            </div>-->
                            <!--<div class="col-6 p-1">
                                <div @click="visanet" class="item-menu">
                                    Pago Visanet
                                </div>
                            </div>-->
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>

import Layout from "../../../global/components/Layout";
import AndroidBridge from "src/core/AndroidBridge";


export default {
    props: {
    },
    data() {
        return {
            isOnApp: false,
            androidBridge: false,
        };
    },
    components: {
        //TimelineChart,
        Layout,
        //Toster,
    },
    mounted() {
        this.androidBridge = new AndroidBridge();
        this.androidBridge.enablePressBackToOut('http://localhost/');
    },
    methods: {
        /*visanet() {
            const test = new AndroidBridge();
            test.VisanetPayApp();
        }*/
    }
};
</script>
